const React = require('react');
const Forms = require('./../../Forms');
const isNode = (typeof process !== 'undefined');

class Form extends React.Component {
    constructor(props) {
        super(props);
    }
    render() {
        if (isNode) console.log(this.props);
        const {hideHeaders, hidePicker, selectedForm, color, emailServiceUrl, title, intro, formSubmitSuccessPageUrl} = this.props;
        return (
            <div className="single-form">
                {title && <h1 className="single-form__title">{title}</h1>}
                <div className="single-form__content" dangerouslySetInnerHTML={{__html: intro}}/>
                <Forms emailServiceUrl={emailServiceUrl} hideHeaders={hideHeaders} hidePicker={hidePicker} selectedForm={selectedForm} color={color} formSubmitSuccessPageUrl={formSubmitSuccessPageUrl}/>
            </div>
        )
    }
}

module.exports = Form;


// WEBPACK FOOTER //
// ./src/main/resources/site/parts/form/Component/index.jsx